import { object } from "yup";

import contactDataSchema from "./contactDataSchema";
import { createBillingDataSchema } from "./billingDataSchema";

const createYourDataSchema = (options) =>
  object({
    ...contactDataSchema.fields,
    ...createBillingDataSchema(options).fields,
  });

export const yourDataSchemaWithoutNipCheck = createYourDataSchema({
  validateNip: false,
});

const yourDataSchema = createYourDataSchema();

export default yourDataSchema;
